<template>
  <Teleport to="body">
    <Toaster class="d3-toast" position="top-center" richColors offset="20px" :visibleToasts=1   :expand="false"/>

  </Teleport>
</template>

<script setup lang="ts">
import { Toaster } from 'vue-sonner';
import 'vue-sonner/style.css';

</script>


<style lang="scss">
.d3-toast {
  z-index: 99999 !important;
  li{
    height: auto !important;
  }

}

//移除  /*scoped*/
[data-sonner-toast] {
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  font-size: 14px !important;
  padding: 14px 18px !important;
  min-height: auto !important;
  width: fit-content !important;
  max-width: 80% !important;
  /* gap: 12px !important; */
  margin: 0 auto !important;
  text-align: center !important;
  display: flex !important;
  align-items: center !important;
}

/* Success 类型 toast */
[data-sonner-toast][data-type="success"] {
  background-color: #4caf50 !important;
  color: #ffffff !important;
  border: none !important;
}

[data-sonner-toast][data-type="success"] [data-title] {
  color: #ffffff !important;
}

/* Error 类型 toast */
[data-sonner-toast][data-type="error"] {
  background-color: #f44336 !important;
  color: #ffffff !important;
  border: none !important;
}

[data-sonner-toast][data-type="error"] [data-title] {
  color: #ffffff !important;
}

/* Info 类型 toast */
[data-sonner-toast][data-type="info"] {
  background-color: #2196f3 !important;
  color: #ffffff !important;
  border: none !important;
}

[data-sonner-toast][data-type="info"] [data-title] {
  color: #ffffff !important;
}

/* Warning 类型 toast */
[data-sonner-toast][data-type="warning"] {
  background-color: #ff9800 !important;
  color: #ffffff !important;
  border: none !important;
}

[data-sonner-toast][data-type="warning"] [data-title] {
  color: #ffffff !important;
}

/* Default 类型 toast */
[data-sonner-toast][data-type="default"] {
  background-color: #323232 !important;
  color: #ffffff !important;
  border: none !important;
}

[data-sonner-toast][data-type="default"] [data-title] {
  color: #ffffff !important;
}

/* Toast 标题样式 */
[data-sonner-toast] [data-title] {
  font-weight: 500 !important;
  line-height: 1.5 !important;
  color: inherit !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
  white-space: normal !important;
  flex: 1 !important;
  min-width: 0 !important;
}

/* Toast 图标样式 - 增加图标和文字之间的间距 */
[data-sonner-toast] [data-icon] {
  width: 20px !important;
  height: 20px !important;
  flex-shrink: 0 !important;
}

.sonner-toast {
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  font-size: 14px !important;
  padding: 14px 18px !important;
  min-height: auto !important;
  width: fit-content !important;
  max-width: 80% !important;
  /* gap: 12px !important; */
  display: flex !important;
  align-items: center !important;
}

.sonner-toast[data-type="success"] {
  background-color: #4caf50 !important;
  color: #ffffff !important;
  border: none !important;
}

.sonner-toast[data-type="error"] {
  background-color: #f44336 !important;
  color: #ffffff !important;
  border: none !important;
}

.sonner-toast[data-type="info"] {
  background-color: #2196f3 !important;
  color: #ffffff !important;
  border: none !important;
}

.sonner-toast[data-type="warning"] {
  background-color: #ff9800 !important;
  color: #ffffff !important;
  border: none !important;
}

.sonner-toast[data-type="default"] {
  background-color: #323232 !important;
  color: #ffffff !important;
  border: none !important;
}

.sonner-toast .sonner-toast-title {
  font-weight: 500 !important;
  line-height: 1.5 !important;
  color: inherit !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
  white-space: normal !important;
  flex: 1 !important;
  min-width: 0 !important;
}

.sonner-toast .sonner-icon {
  width: 20px !important;
  height: 20px !important;
  flex-shrink: 0 !important;
}



</style>
